import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';
import {
  CancellationReason,
  CreateCancellationReasonDto,
  UpdateCancellationReasonDto
} from '../interfaces/cancellation-reason.interface';

@Injectable({
  providedIn: 'root'
})
export class CancellationReasonsService {
  private baseUrl = '/api/company/cancellation-reasons';

  constructor(private http: HttpClient) {}

  getCancellationReasons(): Observable<ApiResponse<CancellationReason[]>> {
    return this.http.get<ApiResponse<CancellationReason[]>>(this.baseUrl);
  }

  getCancellationReasonById(id: number): Observable<ApiResponse<CancellationReason>> {
    return this.http.get<ApiResponse<CancellationReason>>(`${this.baseUrl}/${id}`);
  }

  createCancellationReason(dto: CreateCancellationReasonDto): Observable<ApiResponse<CancellationReason>> {
    return this.http.post<ApiResponse<CancellationReason>>(this.baseUrl, dto);
  }

  updateCancellationReason(id: number, dto: UpdateCancellationReasonDto): Observable<ApiResponse<CancellationReason>> {
    return this.http.put<ApiResponse<CancellationReason>>(`${this.baseUrl}/${id}`, dto);
  }

  deleteCancellationReason(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }

  toggleActive(id: number): Observable<ApiResponse<CancellationReason>> {
    return this.http.put<ApiResponse<CancellationReason>>(`${this.baseUrl}/${id}/toggle-active`, {});
  }
}
